module.exports = {"520523001":"西洛街道","520523002":"岩孔街道","520523003":"五龙街道","520523004":"鼓场街道","520523101":"安底镇","520523102":"沙土镇","520523104":"禹谟镇","520523105":"岚头镇","520523106":"清池镇","520523107":"柳塘镇","520523108":"平坝镇","520523109":"源村镇","520523110":"高坪镇","520523111":"化觉镇","520523112":"茶园镇","520523113":"木孔镇","520523114":"长坝镇","520523115":"后山镇","520523202":"石场苗族彝族乡","520523203":"桂花乡","520523204":"太平彝族苗族乡","520523215":"安洛苗族彝族满族乡","520523216":"新化苗族彝族满族乡","520523217":"大田彝族苗族布依族乡","520523218":"马路彝族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520523.json
// module id = 2486
// module chunks = 0